import * as React from 'react';

import CertificateImage from 'bundles/accomplishments/components/shared/CertificateImage';


import 'css!./__styles__/CourseCertificate';

type Props = {
  certificateLink: string;
  userName: string;
  courseName: string;
  universityNames: string;
  certificateImageUrl?: string;
  isCertificateOwner?: boolean;
};

const CourseCertificate = ({
  userName,
  courseName,
  universityNames,
  certificateLink,
  certificateImageUrl,
  isCertificateOwner,
}: Props) => {
  return (
    <div className="rc-CourseCertificate">
      <CertificateImage
        itemName={courseName}
        certificateImageUrl={certificateImageUrl}
        certificatePdfPageLink={certificateLink}
        isCertificateOwner={isCertificateOwner}
        userName={userName}
        universityNames={universityNames}
      />
    </div>
  );
};
export default CourseCertificate;
